import { CONDITION_TYPE } from './constants';

export const getBasicCondition = data => ({
    type: CONDITION_TYPE.basic,
    data
});
